import React from "react"
import Popup from "reactjs-popup"

import Protected from "../../../components/Protected/Protected"
import AssignEquipmentPopup from "./AssignEquipmentPopup"
import DeleteEquipmentPopup from "./DeleteEquipmentPopup"
import CreateUpdateEquipmentPopup from "./CreateUpdateEquipmentPopup"

import CustomScrollableTable from "../../../toolkits/CustomScrollableTable"
import {EmptyResult} from "../../../toolkits/EmptyResult/EmptyResult"
import InfoPopup from "../../../components/InfoPopup"

import {ORDERING_KEYS} from "../const"

import ArrowDown from "@mui/icons-material/KeyboardArrowDown"
import {PERMISSIONS} from "../../../constants/permissions"
import {useTranslation} from "react-i18next"


export const EquipmentTable = ({
    equipment,
    ordering,
    setOrdering,
    refreshTable,
    setUserMessage,
    empty,
}) => {
    const { t } = useTranslation("common")

    const equipmentList = equipment.map((eq, i) => {
        const popupProps = {
            equipment: eq,
            setUserMessage: setUserMessage,
            refreshTable: refreshTable,
        }

        const equipmentActions = (
            <>
                <Protected permissions={[PERMISSIONS.WRITE_EQUIPMENT]}>
                    <Popup trigger={<span className="equipment-content-table-link">{eq.user ? t("Unassign") : t("Assign")}</span>} modal>
                        {close => (
                            eq.user ? <AssignEquipmentPopup assign={false} {...popupProps} close={close}/> :
                                <AssignEquipmentPopup assign={true} {...popupProps} close={close}/>
                        )}
                    </Popup>
                
                    <Popup trigger={<span className="equipment-content-table-link"> {t("Edit")} </span>} modal>
                        {close => (
                            <CreateUpdateEquipmentPopup editFlag={true} {...popupProps} close={close}/>
                        )}
                    </Popup>

                    <Popup trigger={<span className="equipment-content-table-link"> {t("Delete")} </span>} modal>
                        {close => (
                            <DeleteEquipmentPopup equipment={eq} {...popupProps} close={close}/>
                        )}
                    </Popup>
                </Protected>
            </>
        )

        return (
            <tr key={`${i} ${eq.id}`} className="custom-scrollable-table-row">
                <td>
                    <Popup trigger={
                        <span className="cell-limited-text clickable"> {eq.name} </span>} modal>
                        {close => (
                            <InfoPopup
                                title={t("Equipment")}
                                value={eq.name}
                                close={close}
                            />
                        )}
                    </Popup>
                </td>
                <td>
                    {eq.category?.name &&
                        <Popup trigger={
                            <span className="cell-limited-text clickable"> {eq.category?.name} </span>} modal>
                            {close => (
                                <InfoPopup
                                    title={t("Category")}
                                    value={eq.category?.name}
                                    close={close}
                                />
                            )}
                        </Popup>
                    }
                </td>
                <td>
                    {eq.serial_number &&
                        <Popup trigger={
                            <span className="cell-limited-text clickable"> {eq.serial_number} </span>} modal>
                            {close => (
                                <InfoPopup
                                    title={t("Serial Number")}
                                    value={eq.serial_number}
                                    close={close}
                                />
                            )}
                        </Popup>
                    }
                </td>
                <td>{eq.user ? `${eq.user.first_name} ${eq.user.last_name}` : t("No user")}</td>
                <td>
                    {equipmentActions}
                </td>
            </tr>
        )
    })
    
    return (
        <CustomScrollableTable>
            <table className="equipment-content-table">
                <thead>
                    <tr>
                        <th>
                            <span className="custom-scrollable-table-head-span-first">{t("Equipment")}</span>
                            <ArrowDown
                                className={`equipment-content-arrow ${
                                    ordering.key === ORDERING_KEYS.EQUIPMENT
                                        ? !ordering.asc
                                            ? "rotate-arrow active-arrow "
                                            : "active-arrow"
                                        : ""}`}
                                onClick={() => setOrdering({
                                    key: ORDERING_KEYS.EQUIPMENT,
                                    asc: ordering.key === ORDERING_KEYS.EQUIPMENT ? !ordering.asc : true,
                                })}
                            />
                        </th>
                        <th>
                            <span className="custom-scrollable-table-head-span">{t("Category")}</span>
                            <ArrowDown
                                className={`equipment-content-arrow ${
                                    ordering.key === ORDERING_KEYS.CATEGORY
                                        ? !ordering.asc
                                            ? "rotate-arrow active-arrow "
                                            : "active-arrow"
                                        : ""}`}
                                onClick={() => setOrdering({
                                    key: ORDERING_KEYS.CATEGORY,
                                    asc: ordering.key === ORDERING_KEYS.CATEGORY ? !ordering.asc : true,
                                })}
                            />
                        </th>
                        <th><span className="custom-scrollable-table-head-span">{t("Serial number")}</span></th>
                        <th>
                            <span className="custom-scrollable-table-head-span">{t("User")}</span>
                            <ArrowDown
                                className={`equipment-content-arrow ${
                                    ordering.key === ORDERING_KEYS.USER
                                        ? !ordering.asc
                                            ? "rotate-arrow active-arrow "
                                            : "active-arrow"
                                        : ""}`}
                                onClick={() => setOrdering({
                                    key: ORDERING_KEYS.USER,
                                    asc: ordering.key === ORDERING_KEYS.USER ? !ordering.asc : true,
                                })}
                            />
                        </th>    
                        <th><span className="custom-scrollable-table-head-span">{t("Actions")}</span></th>
                    </tr>
                </thead>
                <tbody>
                    {equipmentList}
                    {empty && <EmptyResult/>}
                </tbody>
            </table>
        </CustomScrollableTable>
    )
}

export default EquipmentTable
